import { AssertionType } from "./assertions";
import {
  AppError,
  ApplicationError,
  ErrorType,
  GenericError,
  HardStop,
} from "./error";

export const vulnerableHardstopError = (): HardStop => {
  return {
    type: AppError.HardStop,
    payload: { errorType: [ErrorType.ClsVulnerable] },
  };
};

export const unAuthSigHardstopError = (): HardStop => {
  return {
    type: AppError.HardStop,
    payload: { errorType: [ErrorType.ClsUnAuthSig] },
  };
};

export const noToPaygHardstopError = (): HardStop => {
  return {
    type: AppError.HardStop,
    payload: { errorType: [ErrorType.ClsNoToPayg] },
  };
};

export const ceasedTrainingHardstopError = (): HardStop => {
  return {
    type: AppError.HardStop,
    payload: { errorType: [ErrorType.ClsCeasedTrading] },
  };
};

export const finDiffBBBHardstopError = (): HardStop => {
  return {
    type: AppError.HardStop,
    payload: { errorType: [ErrorType.ClsFinDiffBBB] },
  };
};

export const finDiffFCAHardstopError = (): HardStop => {
  return {
    type: AppError.HardStop,
    payload: { errorType: [ErrorType.ClsFinDiffFCA] },
  };
};

export const comprehensionHardstopError = (): HardStop => {
  return {
    type: AppError.HardStop,
    payload: { errorType: [ErrorType.ClsComprehension] },
  };
};

export const genericError = (): GenericError => {
  return {
    type: AppError.Generic,
    payload: { message: "Generic Error" },
  };
};
export const generateApplicationError = (
  type: AssertionType
): ApplicationError => {
  switch (type) {
    case AssertionType.CanNotUseOnlineJourney:
      return vulnerableHardstopError();
    case AssertionType.AuthorisedToActAndNotMinor:
      return unAuthSigHardstopError();
    case AssertionType.ConsentToUsePAYG:
      return noToPaygHardstopError();
    case AssertionType.BusinessCeasedTrading:
      return ceasedTrainingHardstopError();
    case AssertionType.DiscussFinancialDifficulty:
      return finDiffBBBHardstopError();
    case AssertionType.DiscussPAYGOptions:
      return comprehensionHardstopError();
    case AssertionType.DiscussAlternativeOptions:
      return finDiffFCAHardstopError();
    default:
      return genericError();
  }
};
